import React from 'react';

import { styled } from '@mui/material';
import CustomPaper from '../common/CustomPaper';
import Draggable from 'react-draggable';

const StyledPaper = styled(CustomPaper)(({ customStyles }) => ({
  width: '400px',
  padding: '16px',
  borderRadius: '6px',
  boxShadow: '4px 4px 0px 0px rgba(0, 0, 0, 0.25)',
  border: '1px solid rgba(184, 184, 184, 1)',
  zIndex: '9999 !important',
  cursor: 'move',
  ...customStyles,
}));

const BottomContent = styled('div')({
  maxHeight: '750px',
  overflow: 'hidden',
});

function W86FloatingPane({ topButtons, content, defaultPosition, customStyles }) {
  return (
    <Draggable defaultPosition={defaultPosition ? defaultPosition : {}} handle=".w86-drag-handle">
      <StyledPaper
        elevation={5}
        customStyles={customStyles ? customStyles : {}}
        className="w86-drag-handle"
      >
        <div>{topButtons}</div>
        <BottomContent>{content}</BottomContent>
      </StyledPaper>
    </Draggable>
  );
}

export default W86FloatingPane;
